import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, FileText, LogOut, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  const handleViewInvestorPortal = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex flex-col items-start">
                <img
                  src="https://customer-assets.emergentagent.com/job_fintech-portal-38/artifacts/7o5rddiv_veriquant_logo%20%281%29.webp"
                  alt="Veriquant"
                  className="h-[64px] w-auto cursor-pointer"
                  style={{ imageRendering: 'crisp-edges', WebkitFontSmoothing: 'antialiased' }}
                  onClick={() => navigate('/admin/dashboard')}
                />
                <p className="text-[10px] text-slate-500 font-normal italic mt-1">
                  Merchant Cash Advances: Simple. Fast. Flexible
                </p>
              </div>
              <h1 className="text-2xl font-bold text-slate-900">Admin Portal</h1>
            </div>
            <div className="flex items-center space-x-4">
              <Button onClick={handleViewInvestorPortal} variant="outline" className="flex items-center space-x-2">
                <Eye className="w-4 h-4" />
                <span>View Investor Portal</span>
              </Button>
              <Button onClick={handleLogout} variant="ghost">
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex space-x-8">
            <button
              onClick={() => navigate('/admin/dashboard')}
              className="flex items-center space-x-2 px-3 py-4 border-b-2 border-transparent hover:border-blue-600 transition-colors text-slate-600 hover:text-slate-900"
            >
              <LayoutDashboard className="w-5 h-5" />
              <span>Dashboard</span>
            </button>
            <button
              onClick={() => navigate('/admin/users')}
              className="flex items-center space-x-2 px-3 py-4 border-b-2 border-transparent hover:border-blue-600 transition-colors text-slate-600 hover:text-slate-900"
            >
              <Users className="w-5 h-5" />
              <span>User Management</span>
            </button>
            <button
              onClick={() => navigate('/admin/investors-overview')}
              className="flex items-center space-x-2 px-3 py-4 border-b-2 border-transparent hover:border-blue-600 transition-colors text-slate-600 hover:text-slate-900"
            >
              <Eye className="w-5 h-5" />
              <span>Investors Overview</span>
            </button>
            <button
              onClick={() => navigate('/admin/audit-logs')}
              className="flex items-center space-x-2 px-3 py-4 border-b-2 border-transparent hover:border-blue-600 transition-colors text-slate-600 hover:text-slate-900"
            >
              <FileText className="w-5 h-5" />
              <span>Audit Logs</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
